import script from "./InputQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./InputQuestion.vue?vue&type=script&setup=true&lang=js"

import "./InputQuestion.vue?vue&type=style&index=0&id=6dcc795c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dcc795c"]])

export default __exports__